import React, { useEffect, useState } from 'react';
import styles from './CouponsAdmin.module.css';
import { adminCouponAPI } from '../Handlers/couponAPI';

const CouponsAdmin = () => {
  const [coupons, setCoupons] = useState([]);
  const [form, setForm] = useState({ 
    code: '', 
    amount: 0, 
    is_percentage: false, 
    usage_limit: '',
    active: true 
  });
  const [loading, setLoading] = useState(false);

  useEffect(() => { load(); }, []);

  const load = async () => {
    try {
      const data = await adminCouponAPI.list();
      setCoupons(data || []);
    } catch (err) {
      console.error("Erro ao carregar cupons", err);
    }
  };

  const create = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const payload = {
        ...form,
        usage_limit: form.usage_limit === '' ? null : parseInt(form.usage_limit)
      };
      await adminCouponAPI.create(payload);
      setForm({ code: '', amount: 0, is_percentage: false, usage_limit: '', active: true });
      load();
    } catch (err) {
      alert("Erro ao criar cupom. Verifique se o código já existe.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={styles.container}>
      <header className={styles.header}>
        <div>
          <h1>Cupons de Desconto</h1>
          <p>Crie e gerencie promoções para seus clientes.</p>
        </div>
      </header>

      <div className={styles.layout}>
        {/* Formulário lateral */}
        <aside className={styles.formCard}>
          <h3>Novo Cupom</h3>
          <form onSubmit={create} className={styles.form}>
            <div className={styles.inputGroup}>
              <label>Código do Cupom</label>
              <input 
                placeholder="EX: PROMO2024" 
                value={form.code} 
                onChange={e => setForm({...form, code: e.target.value.toUpperCase()})} 
                required
              />
            </div>

            <div className={styles.row}>
              <div className={styles.inputGroup} style={{ flex: 2 }}>
                <label>Valor do Desconto</label>
                <div className={styles.amountInputWrapper}>
                  <span className={styles.currencyPrefix}>{form.is_percentage ? '%' : 'R$'}</span>
                  <input 
                    type="number" 
                    step="0.01"
                    value={form.amount} 
                    onChange={e => setForm({...form, amount: parseFloat(e.target.value || 0)})} 
                    required
                  />
                </div>
              </div>
              <div className={styles.toggleGroup}>
                <label>Tipo</label>
                <button 
                  type="button"
                  className={`${styles.toggleBtn} ${form.is_percentage ? styles.activeToggle : ''}`}
                  onClick={() => setForm({...form, is_percentage: !form.is_percentage})}
                >
                  %
                </button>
              </div>
            </div>

            <div className={styles.inputGroup}>
              <label>Limite de Uso (Opcional)</label>
              <input 
                type="number"
                placeholder="Ex: 100 (vazio para ilimitado)" 
                value={form.usage_limit} 
                onChange={e => setForm({...form, usage_limit: e.target.value})} 
              />
            </div>

            <button type="submit" className={styles.btnPrimary} disabled={loading}>
              {loading ? 'Processando...' : 'Gerar Cupom'}
            </button>
          </form>
        </aside>

        {/* Lista de cupons */}
        <main className={styles.listCard}>
          <div className={styles.tableWrapper}>
            <table className={styles.table}>
              <thead>
                <tr>
                  <th>Código</th>
                  <th>Desconto</th>
                  <th>Uso Restante</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                {coupons.map(c => (
                  <tr key={c.id}>
                    <td><span className={styles.couponCode}>{c.code}</span></td>
                    <td className={styles.amountCell}>
                      {c.is_percentage ? `${c.amount}%` : `R$ ${c.amount.toFixed(2)}`}
                    </td>
                    <td>
                      <span className={styles.usageText}>
                        {c.usage_limit !== null ? `${c.usage_limit} un.` : '∞ Ilimitado'}
                      </span>
                    </td>
                    <td>
                      <span className={`${styles.statusBadge} ${c.active ? styles.bgSuccess : styles.bgMuted}`}>
                        {c.active ? 'Ativo' : 'Inativo'}
                      </span>
                    </td>
                  </tr>
                ))}
                {coupons.length === 0 && (
                  <tr><td colSpan="4" className={styles.empty}>Nenhum cupom ativo.</td></tr>
                )}
              </tbody>
            </table>
          </div>
        </main>
      </div>
    </div>
  );
};

export default CouponsAdmin;